import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  uniq, map, find, cloneDeep,
  each, sortBy, get,
} from 'lodash';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { format as formatMoney } from '../../../../components/money-display';

import {
  getWinLossOpportunities,
} from '../../../Dashboard/DashboardReducer';
import DropdownRange from '../../../../components/dropdown-range';
import { getHasNoDecisionSetup } from '../../../../components/search-form/search-form-reducer';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import Pie from '../../../Analysic/components/graphs/pie';
import styles from './styles.css';

const ANNUAL_REVENUE = 'ANNUAL_REVENUE';
const EMPLOYEE_COUNT = 'EMPLOYEE_COUNT';

const USER_PREFERENCE_REPORT_TYPE = 'leaderboard-account-size-graph-report-type';
const USER_PREFERENCE_SIZE_TYPE = 'leaderboard-account-size-graph-size-type';

export function getDefautlIndexFromTotal(total) {
  const lowerIndex = Math.floor((total / 3) - 1);
  const upperIndex = Math.floor((2 * (total / 3)) - 1);
  return [lowerIndex, upperIndex];
}

export function getIndexesFromBuckets(buckets = [], attribute = 'amount') {
  return uniq(map(sortBy(buckets, b => get(b, attribute) || 0), item => Math.round((get(item, attribute) || 0) * 100) / 100));
}

export function getBreakDownBuckets(buckets, amountIndex, minIndex, maxIndex, attribute = 'amount') {
  const lowerAmount = amountIndex[minIndex];
  const upperAmount = amountIndex[maxIndex];

  const oneStat = {
    total: 0,
    amount: 0,
    min: null,
    max: 0,
    stats: {
      won: { total: 0, amount: 0, opportunityIds: [], unit: 'with Request' },
      lost: { total: 0, amount: 0, opportunityIds: [], unit: 'without Request' },
    },
  };

  const results = {
    large: cloneDeep(oneStat),
    medium: cloneDeep(oneStat),
    small: cloneDeep(oneStat),
    total: cloneDeep(oneStat),
  };
  each(buckets, (item) => {
    let bucketType = 'medium';
    const amount = get(item, attribute) || 0;
    if (amount <= lowerAmount) {
      bucketType = 'small';
    } else if (amount >= upperAmount) {
      bucketType = 'large';
    }
    each([bucketType, 'total'], (type) => {
      const bucket = results[type];
      const stage = item.has_requests ? 'won' : 'lost';
      if (bucket.stats[stage]) {
        bucket.amount += amount;
        bucket.max = Math.max(bucket.max, amount);
        if (bucket.min === null) {
          bucket.min = amount;
        } else {
          bucket.min = Math.min(bucket.min, amount);
        }
        bucket.total += 1;
        bucket.stats[stage].total += 1;
        bucket.stats[stage].amount += amount || 0;
        bucket.stats[stage].opportunityIds.push(item.opportunity_id);
      }
    });
  });
  return results;
}


class AccountSizeChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: 'amount',
      sizeType: ANNUAL_REVENUE,

      annualRevenueIndex: [],
      employeeCountIndex: [],

      annualRevenueBounds: [0, 0],
      employeeCountBounds: [0, 0],

      buckets: null,
    };
    this.onSliderChange = this.onSliderChange.bind(this);
    this.setReportType = this.setReportType.bind(this);
    this.setSizeType = this.setSizeType.bind(this);
  }

  componentWillMount() {
    const { opportunities } = this.props;
    const reportType = this.context.getUserPreference(USER_PREFERENCE_REPORT_TYPE, 'amount');
    const sizeType = this.context.getUserPreference(USER_PREFERENCE_SIZE_TYPE, ANNUAL_REVENUE);
    
    const annualRevenueIndex = getIndexesFromBuckets(opportunities, 'account.annual_revenue');
    const employeeCountIndex = getIndexesFromBuckets(opportunities, 'account.number_of_employees');

    const annualRevenueBounds = getDefautlIndexFromTotal(annualRevenueIndex.length);
    const employeeCountBounds = getDefautlIndexFromTotal(employeeCountIndex.length);

    this.setState({
      reportType, annualRevenueIndex, employeeCountIndex, annualRevenueBounds, employeeCountBounds, sizeType,
    }, this.calculate);
  }

  onSliderChange(bounds) {
    const { sizeType } = this.state;
    if (sizeType === ANNUAL_REVENUE) {
      this.setState({ annualRevenueBounds: bounds }, this.calculate);
    } else {
      this.setState({ employeeCountBounds: bounds }, this.calculate);
    }
  }

  getBucketSubTitle(bucket) {
    const { organization } = this.props;
    let suffix = '';
    let symbol = '';
    if (organization) {
      suffix = organization.currency_suffix;
      symbol = organization.currency_symbol;
    }
    const min = formatMoney(bucket.min, true, 1, symbol);
    const max = formatMoney(bucket.max, true, 1, symbol, suffix);
    return `${min} - ${max}`;
  }

  getBucketTitle(title, bucket) {
    const titleSuffix = `ACCOUNT${(bucket.total !== 1 ? 'S' : '')}`;
    return `${title} ${titleSuffix}`;
  }

  setReportType(reportType) {
    this.setState({ reportType }, this.calculate);
    this.context.updateUserPreference(USER_PREFERENCE_REPORT_TYPE, reportType);
  }

  setSizeType(sizeType) {
    this.setState({ sizeType }, this.calculate);
    this.context.updateUserPreference(USER_PREFERENCE_SIZE_TYPE, sizeType);
  }

  calculate() {
    const { opportunities } = this.props;
    const {
      sizeType,
      annualRevenueIndex, annualRevenueBounds,
      employeeCountIndex, employeeCountBounds,
    } = this.state;
    let buckets = [];
    if (sizeType === 'EMPLOYEE_COUNT') {
      buckets = getBreakDownBuckets(opportunities, employeeCountIndex, employeeCountBounds[0], employeeCountBounds[1], 'account.number_of_employees');
    } else {
      buckets = getBreakDownBuckets(opportunities, annualRevenueIndex, annualRevenueBounds[0], annualRevenueBounds[1], 'account.annual_revenue');
    }
    this.setState({ buckets });
  }

  render() {
    const {
      reportType, buckets, sizeType,
      annualRevenueIndex, employeeCountIndex,
      annualRevenueBounds, employeeCountBounds,
    } = this.state;
    const { organization, hasNoDecisionSetup } = this.props;
    const reportTypes = [
      { value: 'amount', label: 'Amount' },
      { value: 'count', label: 'Count' },
    ];

    const sizeTypes = [
      { value: ANNUAL_REVENUE, label: 'Annual Revenue' },
      { value: EMPLOYEE_COUNT, label: 'Employee Count' },
    ];

    let fieldSuffix = '';
    let fieldPrefix = '';
    if (organization) {
      fieldSuffix = organization.currency_suffix;
      fieldPrefix = organization.currency_symbol;
    }

    const activeReportType = find(reportTypes, { value: reportType }) || { label: 'Amount' };
    const activeSizeType = find(sizeTypes, { value: sizeType }) || { label: 'Annual Revenue' };


    return (
      <div className="animated fadeIn">
        <div>
          <h5 className="sub-header-with-controls">
            View
            {' '}
            <Dropdown
              id="leaderboard-account-bucket-report-type-dropdown"
            >
              <Dropdown.Toggle bsSize="small">
                {activeReportType.label}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {reportTypes.map(s => (
                  <MenuItem
                    key={s.value}
                    active={s.value === reportType}
                    onSelect={() => { this.setReportType(s.value); }}
                  >
                    {s.label}
                  </MenuItem>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
            {' '}
            feedback request rates in small, medium, and large account with
            {' '}
            <Dropdown
              id="leaderboard-account-bucket-size-type-dropdown"
            >
              <Dropdown.Toggle bsSize="small">
                {activeSizeType.label}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {sizeTypes.map(s => (
                  <MenuItem
                    key={s.value}
                    active={s.value === sizeType}
                    onSelect={() => { this.setSizeType(s.value); }}
                  >
                    {s.label}
                  </MenuItem>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
            {' '}
            boundaries
            {' '}
            {buckets !== null && buckets.total.total && <DropdownRange
              key={sizeType}
              values={sizeType === ANNUAL_REVENUE ? annualRevenueIndex : employeeCountIndex}
              bounds={sizeType === ANNUAL_REVENUE ? annualRevenueBounds : employeeCountBounds}
              onSliderChange={this.onSliderChange}
              modalProps={{
                fieldPrefix,
                fieldSuffix,
                title: 'Small, Medium and Large Account Size Boundaries',
                lowerLabel: 'Medium Size Start',
                upperLabel: 'Large Size Start',
              }}
            />}
          </h5>

          {buckets !== null &&
            <div className={`row ${styles.opportunityGraphs}`}>
              <div className="col-sm-4">
                <Pie
                  reportType={reportType}
                  bucket={buckets.small}
                  type="small"
                  hasNoDecisionSetup={hasNoDecisionSetup}
                  subTitle={this.getBucketSubTitle(buckets.small)}
                  title={this.getBucketTitle('SMALL', buckets.small)}
                  onChartSegmentSelect={this.props.onOpportunitySelect}
                />
              </div>
              <div className="col-sm-4">
                <Pie
                  reportType={reportType}
                  bucket={buckets.medium}
                  type="medium"
                  hasNoDecisionSetup={hasNoDecisionSetup}
                  subTitle={this.getBucketSubTitle(buckets.medium)}
                  title={this.getBucketTitle('MEDIUM', buckets.medium)}
                  onChartSegmentSelect={this.props.onOpportunitySelect}
                />
              </div>
              <div className="col-sm-4">
                <Pie
                  reportType={reportType}
                  bucket={buckets.large}
                  type="large"
                  hasNoDecisionSetup={hasNoDecisionSetup}
                  subTitle={this.getBucketSubTitle(buckets.large)}
                  title={this.getBucketTitle('LARGE', buckets.large)}
                  onChartSegmentSelect={this.props.onOpportunitySelect}
                />
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}


AccountSizeChart.propTypes = {
  opportunities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hasNoDecisionSetup: PropTypes.bool.isRequired,
  organization: PropTypes.shape({}).isRequired,
  onOpportunitySelect: PropTypes.func,
};

AccountSizeChart.defaultProps = {
  onOpportunitySelect: () => {},
};

AccountSizeChart.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  getUserPreference: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    opportunities: getWinLossOpportunities(state),
    hasNoDecisionSetup: getHasNoDecisionSetup(state),
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps)(AccountSizeChart);
